import CommomProxy from '@/components/proxy/CommomProxy'

let title = '视频门诊';
let child_routes = [{
        path: '',
        name: 'def',
        redirect: "enterView" // 重定向到 入口enter页
    },
    {
        path: 'index', // 旧版入口页
        name: 'index',
        redirect: "enterView", // 重定向到 入口enter页
        // component: resolve => {
        //   require(['@/views/video/index/index.vue'], resolve);
        // },
        meta: {
            needLogin: false,
            login: 'Member'
        }
    },
    {
        path: 'businessView',
        name: 'businessView',
        component: resolve => {
            require(['@/views/video/index/businessView.vue'], resolve);
        },
        meta: {
            needLogin: true,
            login: 'Member'
        }
    },
    {
        path: 'enterView',
        name: 'enterView',
        component: resolve => {
            require(['@/views/video/index/enterView.vue'], resolve);
        },
        meta: {}
    },
    {
        path: 'newView',
        name: 'newView',
        component: resolve => {
            require(['@/views/video/index/newView.vue'], resolve);
        },
        meta: {
            needLogin: true,
            login: 'Member'
        }
    },
    {
        path: 'home', // IM环信页面 已弃用
        name: 'home',
        component: resolve => {
            require(['@/views/video/index/home.vue'], resolve);
        },
        meta: { needLogin: true, }

    },
    {
        path: 'recordList',
        name: 'recordList',
        component: resolve => {
            require(['@/views/video/record/recordList.vue'], resolve);
        },
        meta: { needLogin: true, }
    },
    {
        path: 'recordDetail',
        name: 'recordDetail',
        component: resolve => {
            require(['@/views/video/record/recordDetail.vue'], resolve);
        },
        meta: { needLogin: true, }
    },
    {
        path: 'evalSuccess',
        name: 'evalSuccess',
        component: resolve => {
            require(['@/views/video/record/evalSuccess.vue'], resolve);
        },
        meta: { needLogin: true, }
    },
    {
        path: 'evalLoading',
        name: 'evalLoading',
        component: resolve => {
            require(['@/views/video/record/evalLoading.vue'], resolve);
        },
        meta: { needLogin: true, }
    },

    {
        path: 'presentDetil',
        name: 'presentDetil',
        component: resolve => {
            require(['@/views/video/present/presentDetil.vue'], resolve);
        },
        meta: { needLogin: true, }
    },
    {
        path: 'Perfect',
        name: 'Perfect',
        component: resolve => {
            require(['@/views/video/Perfect/Perfect.vue'], resolve);
        },
        meta: { needLogin: true, }
    },
    {
        path: 'Addition',
        name: 'Addition',
        component: resolve => {
            require(['@/views/video/Perfect/Addition.vue'], resolve);
        },
        meta: { needLogin: true, }
    },
    {
        path: 'Addpatients',
        name: 'Addpatients',
        component: resolve => {
            require(['@/views/video/Perfect/Addpatients.vue'], resolve);
        },
        meta: { needLogin: true, }
    },
    {
        path: 'AddpatientsNew',
        name: 'AddpatientsNew',
        component: resolve => {
            require(['@/views/video/Perfect/AddpatientsNew.vue'], resolve);
        },
        meta: { needLogin: true, }
    },
    {
        path: 'Member',
        name: 'Member',
        component: resolve => {
            require(['@/views/video/Member/Member.vue'], resolve);
        },
        meta: { needLogin: false }

    },
    {
        path: 'MemberOld',
        name: 'MemberOld',
        component: resolve => {
            require(['@/views/video/Member/MemberOld.vue'], resolve);
        },
        meta: { needLogin: false, }

    },
    {
        path: 'live_question',
        name: 'live_question',
        component: resolve => {
            require(['@/views/video/Member/live_question.vue'], resolve);
        },
        meta: { needLogin: false, }
    },
    {
        path: 'dialog',
        name: 'dialog',
        component: resolve => {
            require(['@/views/video/dialog/1V1.vue'], resolve);
        },
        meta: { needLogin: true, },
        props: true
    },
    {
        path: 'success',
        name: 'success',
        component: resolve => {
            require(['@/views/video/activation/success.vue'], resolve);
        },
        meta: { needLogin: true },
    },
    {
        path: 'activatedList',
        name: 'activatedList',
        component: resolve => {
            require(['@/views/video/activation/activatedList.vue'], resolve);
        },
        meta: { needLogin: true },
    },
	{
		path: 'southAus',
		name: 'southAus',
		component: resolve => {
			require(['@/views/video/southAus/index.vue'], resolve);
		},
		meta: {}
	},
	{
	    path: 'southAusView',
	    name: 'southAusView',
	    component: resolve => {
	        require(['@/views/video/southAus/view.vue'], resolve);
	    },
	    meta: { needLogin: true },
	},{
	    path: 'about',
	    name: 'about',
	    component: resolve => {
	        require(['@/views/video/southAus/about.vue'], resolve);
	    },
	    meta: { 
			title:'关于我们'
		},
	},{
	    path: 'agreement',
	    name: 'agreement',
	    component: resolve => {
	        require(['@/views/video/southAus/agreement.vue'], resolve);
	    },
	    meta: { 
			title:'用户协议'
		},
	}
]

child_routes.map(r => {
    if (!r.meta) {
        r.meta = {}
    }
    if (!r.meta.title) {
        r.meta.title = title;
    }
})


let route = [{
    path: '/Video',
    component: CommomProxy,
    children: child_routes
}]

export default route


// WEBPACK FOOTER //
// ./src/router/video.js